export default __webpack_public_path__ + "static/media/PowerGrotesk-UltraBoldItalic.84b50ace.otf";